import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=30f4c87c&scoped=true&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"
import style0 from "./Forms.vue?vue&type=style&index=0&id=30f4c87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f4c87c",
  null
  
)

export default component.exports